/* GENERADO por tools/farmacias/build.py — no editar a mano */
window.NDK_FARMACIAS = {
 "generado": "2026-08-28",
 "total": 40,
 "comunidades": 12,
 "farmacias": [
  {
   "id": "farmacia-castello-110",
   "nombre": "FARMACIA CASTELLO 110",
   "direccion": "Calle de Castelló, 110",
   "cp": "28006",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": "915623214",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 40.4357099,
   "lng": -3.6805601,
   "precision": "exacta"
  },
  {
   "id": "farmacia-lh7",
   "nombre": "FARMACIA LH7",
   "direccion": "C. de López de Hoyos, 7",
   "cp": "28006",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": "910594326",
   "web": "https://www.farmacialopezdehoyos.es",
   "instagram": "https://www.instagram.com/farmacialopezdehoyos",
   "alta": "2026-08-28",
   "lat": 40.4369859,
   "lng": -3.6874856,
   "precision": "exacta"
  },
  {
   "id": "farmacia-zurbano-54",
   "nombre": "FARMACIA ZURBANO 54",
   "direccion": "Calle Zurbano, 54",
   "cp": "28010",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": "913199117",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 40.4342856,
   "lng": -3.6931173,
   "precision": "exacta"
  },
  {
   "id": "farmacia-chamberi",
   "nombre": "FARMACIA CHAMBERI",
   "direccion": "C/ del Gral. Álvarez de Castro, 24",
   "cp": "28010",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": null,
   "web": "https://www.farmaciachamberi.com",
   "instagram": "https://www.instagram.com/farma_chamberi",
   "lat": 40.436102,
   "lng": -3.702276,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "farmacia-collazo",
   "nombre": "FARMACIA COLLAZO",
   "direccion": "C/ de Hortaleza, 2",
   "cp": "28004",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": "915222772",
   "web": null,
   "instagram": "https://www.instagram.com/farmaciacollazo",
   "alta": "2026-08-28",
   "lat": 40.4204129,
   "lng": -3.7008862,
   "precision": "exacta"
  },
  {
   "id": "parafarmacia-sol",
   "nombre": "PARAFARMACIA SOL",
   "direccion": "Puerta del Sol, 14",
   "cp": "28013",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": "915312514",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 40.4171165,
   "lng": -3.7026333,
   "precision": "exacta"
  },
  {
   "id": "farmacia-33-diamantes",
   "nombre": "FARMACIA 33 DIAMANTES",
   "direccion": "Calle del Diamante, 33",
   "cp": "28021",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": "917975249",
   "web": null,
   "instagram": "https://www.instagram.com/33diamantesfarmacia",
   "alta": "2026-08-28",
   "lat": 40.3512025,
   "lng": -3.6863107,
   "precision": "exacta"
  },
  {
   "id": "farmacia-borja-esquivias-perez",
   "nombre": "FARMACIA BORJA ESQUIVIAS PEREZ",
   "direccion": "C. de Cártama, 2",
   "cp": "28018",
   "ciudad": "MADRID",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": null,
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 40.3848593,
   "lng": -3.6397313,
   "precision": "exacta"
  },
  {
   "id": "farmacia-club-de-campo",
   "nombre": "FARMACIA CLUB DE CAMPO",
   "direccion": "Pl. de Antonio de Cabezón, 1",
   "cp": "28706",
   "ciudad": "SAN SEBASTIAN DE LOS REYES",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": null,
   "web": null,
   "instagram": null,
   "lat": 40.610016,
   "lng": -3.583049,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "farmacia-ayala-53",
   "nombre": "Farmacia Ayala 53",
   "direccion": "Calle Ayala, 53",
   "cp": "28001",
   "ciudad": "Madrid",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": null,
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 40.4275323,
   "lng": -3.6783347,
   "precision": "exacta"
  },
  {
   "id": "farmacia-de-pereda",
   "nombre": "Farmacia De Pereda",
   "direccion": "C. Vía del Berrocal, 47",
   "cp": "28411",
   "ciudad": "Moralzarzal",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": null,
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 40.681343,
   "lng": -3.9659438,
   "precision": "exacta"
  },
  {
   "id": "farmacia-tucan-9",
   "nombre": "Farmacia Tucán 9",
   "direccion": "C. de Tucán, 9, Carabanchel",
   "cp": "28025",
   "ciudad": "Madrid",
   "provincia": "MADRID",
   "comunidad": "MADRID",
   "telefono": null,
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 40.3899402,
   "lng": -3.7414824,
   "precision": "calle"
  },
  {
   "id": "farmacia-3-cantos",
   "nombre": "FARMACIA 3 CANTOS",
   "direccion": "Av. Camí del Mas, 12, B",
   "cp": "08192",
   "ciudad": "Sant Quirze del Vallès",
   "provincia": "BARCELONA",
   "comunidad": "CATALUÑA",
   "telefono": "937210783",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 41.5324723,
   "lng": 2.0860871,
   "precision": "exacta"
  },
  {
   "id": "farmacia-sanchez-catala",
   "nombre": "FARMACIA SANCHEZ CATALA",
   "direccion": "Carrer Ciutat Cooperativa, 100",
   "cp": "08830",
   "ciudad": "SAN BOI DE LLOBREGAT",
   "provincia": "BARCELONA",
   "comunidad": "CATALUÑA",
   "telefono": "936406945",
   "web": "https://farmacialacoopesantboifmas.com",
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 41.3578445,
   "lng": 2.0317234,
   "precision": "exacta"
  },
  {
   "id": "farmacia-schultz-79-c-b",
   "nombre": "FARMACIA SCHULTZ 79 C.B.",
   "direccion": "Av. Schulz, 79, Centro, 33208 Gijón, Asturias",
   "cp": "33208",
   "ciudad": "GIJON",
   "provincia": "GIJON",
   "comunidad": "ASTURIAS",
   "telefono": "985386431",
   "web": "https://farmacias79.com",
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 43.5317176,
   "lng": -5.666015,
   "precision": "calle"
  },
  {
   "id": "farmacia-blesa-cb",
   "nombre": "FARMACIA BLESA CB",
   "direccion": "C. la Gloria, 1, 18500 Guadix, Granada",
   "cp": "18500",
   "ciudad": "GUADIX",
   "provincia": "GRANADA",
   "comunidad": "ANDALUCIA",
   "telefono": "958660259",
   "web": "https://www.farmaciablesaguadix.es",
   "instagram": "https://www.instagram.com/farmaciablesaguadix",
   "alta": "2026-08-28",
   "lat": 37.2976328,
   "lng": -3.1350268,
   "precision": "calle"
  },
  {
   "id": "farmacia-rodulfo-cb",
   "nombre": "FARMACIA RODULFO CB",
   "direccion": "Calle Lope de Rueda, 171",
   "cp": "29190",
   "ciudad": "MALAGA",
   "provincia": "MALAGA",
   "comunidad": "ANDALUCIA",
   "telefono": "952438167",
   "web": "https://farmaciarodulfo.es",
   "instagram": "https://www.instagram.com/farmaciarodulfo",
   "alta": "2026-08-28",
   "lat": 36.7442218,
   "lng": -4.490875,
   "precision": "exacta"
  },
  {
   "id": "farmacia-del-mar",
   "nombre": "FARMACIA DEL MAR",
   "direccion": "Av. Condes de San Isidro, 57, 29640 Fuengirola, Málaga",
   "cp": "29640",
   "ciudad": "Fuengirola",
   "provincia": "MALAGA",
   "comunidad": "ANDALUCIA",
   "telefono": "952470268",
   "web": "https://farmaciadelmarfuengirola.com",
   "instagram": "https://www.instagram.com/farmaciadelmarfuengirola",
   "alta": "2026-08-28",
   "lat": 36.5357952,
   "lng": -4.6261166,
   "precision": "calle"
  },
  {
   "id": "farmacia-el-morche",
   "nombre": "Farmacia El Morche",
   "direccion": "Carr. de Almería, 190, bajo",
   "cp": "29793",
   "ciudad": "El Morche",
   "provincia": "MALAGA",
   "comunidad": "ANDALUCIA",
   "telefono": "952553058",
   "web": null,
   "instagram": null,
   "lat": 36.739127,
   "lng": -3.992879,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "farmacia-eloisa-molina",
   "nombre": "Farmacia Eloísa Molina",
   "direccion": "C. Fray Luis de León, 14",
   "cp": "29014",
   "ciudad": "Málaga",
   "provincia": "Málaga",
   "comunidad": "ANDALUCIA",
   "telefono": "952654174",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 36.749886,
   "lng": -4.4226462,
   "precision": "exacta"
  },
  {
   "id": "farmacia-garcia-carmona",
   "nombre": "Farmacia García Carmona",
   "direccion": "C. Huéscar, 2",
   "cp": "29007",
   "ciudad": "Málaga",
   "provincia": "Málaga",
   "comunidad": "ANDALUCIA",
   "telefono": "952391549",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 36.7182027,
   "lng": -4.4311893,
   "precision": "exacta"
  },
  {
   "id": "farmacia-futura",
   "nombre": "Farmacia Futura",
   "direccion": "C. Maestro Alonso, 3, Carretera de Cádiz,",
   "cp": "29002",
   "ciudad": "Málaga",
   "provincia": "Málaga",
   "comunidad": "ANDALUCIA",
   "telefono": "680863968",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 36.7066148,
   "lng": -4.4359409,
   "precision": "exacta"
  },
  {
   "id": "farmacia-jose-manuel-gomez-lora",
   "nombre": "Farmacia José Manuel Gómez Lora",
   "direccion": "C. Abogado Federico Orellana Toledano, 3, Carretera de Cádiz",
   "cp": "29003",
   "ciudad": "Málaga",
   "provincia": "Málaga",
   "comunidad": "ANDALUCIA",
   "telefono": "952316046",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 36.7020544,
   "lng": -4.4393371,
   "precision": "exacta"
  },
  {
   "id": "farmacia-girasoles",
   "nombre": "Farmacia Girasoles",
   "direccion": "C. Gallito, 5, Carretera de Cádiz",
   "cp": "29004",
   "ciudad": "Málaga",
   "provincia": "Málaga",
   "comunidad": "ANDALUCIA",
   "telefono": "952231538",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 36.6953669,
   "lng": -4.4531849,
   "precision": "exacta"
  },
  {
   "id": "farmacia-variante",
   "nombre": "Farmacia Variante",
   "direccion": "Av. Blas Infante, 25",
   "cp": "29120",
   "ciudad": "Alhaurín el Grande",
   "provincia": "Málaga",
   "comunidad": "ANDALUCIA",
   "telefono": "952594556",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 36.6373006,
   "lng": -4.6916204,
   "precision": "exacta"
  },
  {
   "id": "farmacia-hispana",
   "nombre": "FARMACIA HISPANA",
   "direccion": "C. Alcalde Fructuoso Miaja Sánchez, 4",
   "cp": "51011",
   "ciudad": "CEUTA",
   "provincia": "CEUTA",
   "comunidad": "CEUTA",
   "telefono": "956512530",
   "web": "https://www.farmaciahispania.com",
   "instagram": "https://www.instagram.com/farmaciahispania",
   "lat": 35.888396,
   "lng": -5.307794,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "farmacia-el-principe",
   "nombre": "FARMACIA EL PRINCIPE",
   "direccion": "C. Agrupación Nte., 2",
   "cp": "51003",
   "ciudad": "CEUTA",
   "provincia": "CEUTA",
   "comunidad": "CEUTA",
   "telefono": null,
   "web": null,
   "instagram": "https://www.instagram.com/farmaciaprincipe",
   "lat": 35.875153,
   "lng": -5.3447,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "farmacia-lobato",
   "nombre": "FARMACIA LOBATO",
   "direccion": "Av. Ejército Español, 10",
   "cp": "51002",
   "ciudad": "CEUTA",
   "provincia": "CEUTA",
   "comunidad": "CEUTA",
   "telefono": "956503054",
   "web": "https://farmacialobato.com",
   "instagram": "https://www.instagram.com/farmacialobato",
   "alta": "2026-08-28",
   "lat": 35.8887876,
   "lng": -5.3300329,
   "precision": "exacta"
  },
  {
   "id": "farmacia-campora-el-fraile",
   "nombre": "FARMACIA CAMPORA EL FRAILE",
   "direccion": "Cl. San Sebastian de la Gomera, 31",
   "cp": "38632",
   "ciudad": "Fraile",
   "provincia": "Santa Cruz de Tenerife",
   "comunidad": "CANARIAS",
   "telefono": "922733423",
   "web": "https://farmaciacamporaelfraile.es",
   "instagram": null,
   "lat": 28.012953,
   "lng": -16.667138,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "farmacia-villalba-de-la-sierra",
   "nombre": "FARMACIA VILLALBA DE LA SIERRA",
   "direccion": "C. Río Villalvilla, 6",
   "cp": "16140",
   "ciudad": "VILLALBA DE LA SIERRA",
   "provincia": "CUENCA",
   "comunidad": "CASTILLA LA MANCHA",
   "telefono": "969281007",
   "web": "https://www.farmaciarbvillalbasierra.com",
   "instagram": "https://www.instagram.com/farmacia_raquel_benito",
   "alta": "2026-08-28",
   "lat": 40.2301701,
   "lng": -2.0924315,
   "precision": "exacta"
  },
  {
   "id": "farmacia-de-mera",
   "nombre": "FARMACIA DE MERA",
   "direccion": "Paseo Lagoa, 26",
   "cp": "15177",
   "ciudad": "MERA",
   "provincia": "A CORUÑA",
   "comunidad": "GALICIA",
   "telefono": "981617937",
   "web": "https://farmaciademera.com",
   "instagram": null,
   "lat": 43.379344,
   "lng": -8.337457,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "farmacia-galenus",
   "nombre": "FARMACIA GALENUS",
   "direccion": "Rda. Pontevedra, 69",
   "cp": "15800",
   "ciudad": "MELIDE",
   "provincia": "A CORUÑA",
   "comunidad": "GALICIA",
   "telefono": "881976604",
   "web": "https://farmaciagalenus.es",
   "instagram": "https://www.instagram.com/farmacia_galenus",
   "alta": "2026-08-28",
   "lat": 42.9092076,
   "lng": -8.0156481,
   "precision": "exacta"
  },
  {
   "id": "farmacia-mariz-perez-c-b",
   "nombre": "Farmacia Mariz Pérez C B",
   "direccion": "Rúa do Progreso, 8",
   "cp": "36960",
   "ciudad": "Sanxenxo",
   "provincia": "Pontevedra",
   "comunidad": "GALICIA",
   "telefono": "986724278",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 42.4018681,
   "lng": -8.8031645,
   "precision": "exacta"
  },
  {
   "id": "farmacia-medina",
   "nombre": "FARMACIA MEDINA",
   "direccion": "Av. de María del Mar Rodríguez, 32",
   "cp": "03169",
   "ciudad": "Algorfa",
   "provincia": "Alicante",
   "comunidad": "VALENCIA",
   "telefono": "965700077",
   "web": null,
   "instagram": null,
   "lat": 38.087613,
   "lng": -0.795927,
   "precision": "manual",
   "alta": "2026-08-28"
  },
  {
   "id": "botiquin-de-farmacia-la-finca-golf-algorfa",
   "nombre": "BOTIQUIN DE FARMACIA LA FINCA GOLF (ALGORFA)",
   "direccion": "Av. Antonio Pedrera Soler, 1",
   "cp": "03169",
   "ciudad": "Algorfa",
   "provincia": "Alicante",
   "comunidad": "VALENCIA",
   "telefono": "865755145",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 38.0678001,
   "lng": -0.7842232,
   "precision": "exacta"
  },
  {
   "id": "farmacia-olga-perez",
   "nombre": "Farmacia Olga Perez",
   "direccion": "Rodríguez Arias K., 43, Abando, 48011 Bilbao, Bizkaia",
   "cp": "48011",
   "ciudad": "Bilbao",
   "provincia": "Bizkaia",
   "comunidad": "PAIS VASCO",
   "telefono": "944411026",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 43.2627208,
   "lng": -2.9404036,
   "precision": "calle"
  },
  {
   "id": "farmacia-carmen-palos-paz",
   "nombre": "FARMACIA CARMEN PALOS PAZ",
   "direccion": "San Mames Zumarkalea, 29, Abando",
   "cp": "48010",
   "ciudad": "Bilbao",
   "provincia": "Bizkaia",
   "comunidad": "PAIS VASCO",
   "telefono": "944210504",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 43.2589286,
   "lng": -2.9374907,
   "precision": "exacta"
  },
  {
   "id": "orive-gonzalez-farmazia",
   "nombre": "Orive González farmazia",
   "direccion": "Iturribide Kalea, 63, Ibaiondo",
   "cp": "48006",
   "ciudad": "Bilbao",
   "provincia": "Bizkaia",
   "comunidad": "PAIS VASCO",
   "telefono": "944790577",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 43.2565786,
   "lng": -2.9162299,
   "precision": "exacta"
  },
  {
   "id": "farmacia-lazaro-calatayud",
   "nombre": "Farmacia Lázaro Calatayud",
   "direccion": "P.º Cortes de Aragón, 14",
   "cp": null,
   "ciudad": "Calatayud",
   "provincia": "Zaragoza",
   "comunidad": "ARAGON",
   "telefono": "976881831",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 41.3518237,
   "lng": -1.6402485,
   "precision": "exacta"
  },
  {
   "id": "farmacia-raquel-sarmiento",
   "nombre": "Farmacia Raquel Sarmiento",
   "direccion": "C. Ave Maria, 6",
   "cp": "37406",
   "ciudad": "Palaciosrubios",
   "provincia": "Salamanca",
   "comunidad": "CASTILLA Y LEON",
   "telefono": "923533182",
   "web": null,
   "instagram": null,
   "alta": "2026-08-28",
   "lat": 41.0526968,
   "lng": -5.1947369,
   "precision": "exacta"
  }
 ]
};
